/**
 * Cart vest size/color changer. Uses Shopify's documented cart/update.js API,
 * merging quantities safely when the chosen variant is already in the cart.
 */
(() => {
  if (window.wjCartVariantEditInitialized) return;
  window.wjCartVariantEditInitialized = true;
  let updating = false;
  const root = () => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');

  async function jsonRequest(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    const payload = await response.json();
    if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to update your cart.');
    return payload;
  }

  document.addEventListener('change', async (evt) => {
    const select = evt.target;
    if (!select || !select.matches || !select.matches('.wj-cart-variant__select')) return;
    const currentId = String(select.dataset.currentVariant || '');
    const targetId = String(select.value || '');
    if (currentId === targetId) return;
    if (updating) { select.value = currentId; return; }

    const picker = select.closest('.wj-cart-variant');
    const message = picker && picker.querySelector('.wj-cart-variant__error');
    const oldKey = select.dataset.key;
    const stock = select.selectedOptions[0] && select.selectedOptions[0].dataset.stock;
    let cartChanged = false;
    updating = true;
    select.disabled = true;
    if (message) { message.hidden = true; message.textContent = ''; }

    try {
      if (!oldKey || !/^\d+$/.test(targetId)) throw new Error('Please select an available option.');
      const cart = await jsonRequest(root() + 'cart.js');
      const current = (cart.items || []).find(item => item.key === oldKey);
      if (!current || String(current.variant_id) !== currentId) throw new Error('Your cart changed. Please refresh and try again.');
      if ((current.properties && Object.keys(current.properties).length) || current.selling_plan_allocation) {
        throw new Error('Please change this personalized item from its product page.');
      }

      const matches = (cart.items || []).filter(item => String(item.variant_id) === targetId && item.key !== oldKey);
      if (matches.length > 1 || matches.some(item => (item.properties && Object.keys(item.properties).length) || item.selling_plan_allocation)) {
        throw new Error('Please edit this option on its product page.');
      }
      const existing = matches[0];
      const newQuantity = Number(current.quantity) + (existing ? Number(existing.quantity) : 0);
      if (stock !== undefined && stock !== '' && Number(stock) < newQuantity) {
        throw new Error('That option does not have enough stock for this quantity.');
      }

      const updates = {};
      updates[oldKey] = 0;
      updates[existing ? existing.key : targetId] = newQuantity;
      const changed = await jsonRequest(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates })
      });
      cartChanged = true;
      const remainingOld = (changed.items || []).some(item => item.key === oldKey);
      const newLine = (changed.items || []).find(item => String(item.variant_id) === targetId && (!item.properties || Object.keys(item.properties).length === 0));
      if (remainingOld || !newLine || Number(newLine.quantity) < newQuantity) {
        throw new Error('Please double-check your updated cart before checking out.');
      }
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    } catch (error) {
      select.value = currentId;
      if (message) {
        const safeMessage = (error && error.message) || 'Please try again.';
        message.textContent = safeMessage + ' You can also open the product page to change the size.';
        message.hidden = false;
      }
      if (cartChanged) document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    } finally {
      updating = false;
      select.disabled = false;
    }
  });
})();
